import { vnModule_knockoutJS } from "@valnet/vnApp/vnModule_knockoutJS";
import { menuPage_template } from "~/components/templates/menuPage_template";
import { getActiveMenuLabel } from "~/modules/menu_data";
import { header } from "./header";
export class menu_page extends vnModule_knockoutJS {
    getModuleName() {
        return "menu_page";
    }
    internalLoad(container) {
        try {
            this.build();
            this.insertIn(container);
            for (const element of this.content) {
                try {
                    ko.applyBindings(this.viewModel, element);
                }
                catch (error) {
                    console.error("Knockout binding failed for", element.id, error);
                }
            }
            this.loadSavedViewModule();
            this.fillPage();
        }
        finally {
            container.classList.remove("loading");
        }
    }
    buildContent() {
        const pageTitle = getActiveMenuLabel();
        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader?.loadedModule;
        if (loadedModule instanceof header) {
            loadedModule.setHeaderTitle(pageTitle);
        }
        this.tpl = new menuPage_template("menuPage", this.viewModel, this, pageTitle);
        return [this.tpl.build()];
    }
    fillPage() {
        // placeholder page
    }
}
